export default {"src":"/_next/static/media/viewMore.d252646a.svg","height":22,"width":22};